import {
  DatasetDurationManager,
  DatasetSizeManager,
} from "@/services/license/base/license-manager-abstractions";
import { ConvertDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/convert-dataset-duration-limiter";
import { ConvertDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/convert-dataset-size-limiter";

export abstract class ConvertBaseLicenseManager
  implements DatasetDurationManager, DatasetSizeManager
{
  datasetDurationLimiter = new ConvertDatasetDurationLimiter();
  datasetSizeLimiter = new ConvertDatasetSizeLimiter();
}
